import { styled } from "goober";
import { BlueprintOverlay } from "./BlueprintOverlay";
import { CircleMesh } from "./CircleMesh";
import { parseBadgeConfig } from "./CircleMeshEditor";

const BadgeFrame = styled("span")`
  display: flex;
  flex-shrink: 0;
  position: relative;
`;

const Badge = styled("span")`
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 25%;
  overflow: hidden;
`;

export function SmallWorkflowBadge({
  workflow,
  size = 16,
  blueprint = false,
}: {
  workflow: {
    id: string;
    badgeSeed: string | null;
    pausedAt: number | null;
  };
  size?: number;
  blueprint?: boolean;
}) {
  const badge = parseBadgeConfig(workflow.badgeSeed, workflow.id);
  return (
    <BadgeFrame style={{ width: size, height: size }}>
      <Badge style={{ opacity: blueprint ? 0.5 : 1 }}>
        <CircleMesh
          key={badge.seed}
          targetCircleSize={size / 2}
          seed={badge.seed}
          mutingIntensity={0}
          animate={false}
          restrictedColors={badge.colors}
          grayscale={workflow.pausedAt != null}
        />
      </Badge>
      {blueprint && <BlueprintOverlay />}
    </BadgeFrame>
  );
}
